import Report from ".";

export const reportRoutes = (data) => {
  return [
    {
      path: "/admin/reports",
      title: "reports",
      layout: "admin",
      routeType: "admin",
      component: Report,
    },
  ];
};
